import { useEffect } from 'react';
import { declareOpNeeds, type OpScope } from '@/stores/opNeeds';

/** Declare which games' OddsPapi odds this view renders: `'all'` for a board,
 *  a game's wire keys for a single-game view. See `stores/opNeeds`.
 *
 *  Two effects on purpose (the `useFeedNeeds` contract): the declaration
 *  effect re-declares over the top on every change and NEVER clears, and only
 *  the unmount effect clears — so a changing scope never publishes a transient
 *  union with this source missing. `scopeKey` keeps array identity churn from
 *  re-declaring an unchanged scope. */
export function useOpNeeds(sourceId: string, scope: OpScope | null): void {
  const scopeKey = scope == null ? '' : scope === 'all' ? '*' : [...scope].sort().join('\n');
  useEffect(() => {
    if (scopeKey === '') return;
    declareOpNeeds(sourceId, scopeKey === '*' ? 'all' : scopeKey.split('\n'));
  }, [sourceId, scopeKey]);
  useEffect(() => () => declareOpNeeds(sourceId, null), [sourceId]);
}
